import { render } from "./PopupBooking.vue?vue&type=template&id=3d4f115d"
import script from "./PopupBooking.vue?vue&type=script&lang=js"
export * from "./PopupBooking.vue?vue&type=script&lang=js"

import "./PopupBooking.vue?vue&type=style&index=0&id=3d4f115d&lang=css"

import exportComponent from "/home/nimens/projects/cafe-portos/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__